import styles from './RiseClinicSuccessBanner.module.css';

export const RiseClinicSuccessBanner = () => {
  return (
    <div className={styles.container}>
      <div className={styles.banner}>
        <div className={styles.text}>🙏 80% of people who start with an expert chat improve their sleep.</div>
      </div>
    </div>
  );
};
